module.exports = __webpack_public_path__ + "static/media/mainBg.4bd7174e.png";